<framework-launch-button
  (topButtonLaunch)="createProject(projectName.value, true, undefined, $any(workflowTemplateId.value))"
  (bottomButtonLaunch)="createProject(projectName.value, false, undefined, $any(workflowTemplateId.value))"
  [topButtonDisabled]="disabled"
  [bottomButtonDisabled]="disabled || !newProjectForm.valid"
  [disabled]="disabled"
  [loading]="disabled"
  [collapsedWidth]="180"
  [expandedWidth]="230"
  [expandedHeight]="200"
  [(expanded)]="expanded"
  [pauseCollapse]="workflowTemplateId.panelOpen || nameFormField.focused"
>
  <div topButton>Launch Project <mat-icon>launch</mat-icon></div>
  <form #newProjectForm="ngForm" style="margin: 0px">
    <mat-form-field appearance="outline">
      <mat-label>Project Name</mat-label>
      <input
        matInput
        #projectName
        #nameFormField="matInput"
        placeholder="Project Name"
        name="projectName"
        [(ngModel)]="localProjectName"
        [required]="true"
      />
    </mat-form-field>
    <mat-form-field appearance="outline">
      <mat-label>Workflow</mat-label>
      <mat-select #workflowTemplateId [(ngModel)]="templateId" name="templateId" [required]="true">
        <mat-option *ngFor="let template of templates$ | async" [value]="template.id"> {{template.name}} </mat-option>
      </mat-select>
      <!-- <mat-label>Due date</mat-label>
      <input matInput [matDatepicker]="picker" #projectDate placeholder="Due Date" name="dueDate" />
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker
        #picker
        (opened)="pauseCollapse = true;"
        (closed)="pauseCollapse = false;"
      ></mat-datepicker> -->
    </mat-form-field>
  </form>

  <div bottomButton>Quick Create <mat-icon>image</mat-icon></div>
</framework-launch-button>
